"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBPART_L_NOT_ADOPTED = void 0;
exports.getEpisodicRelief = getEpisodicRelief;
exports.episodicEventsApplicableForState = episodicEventsApplicableForState;
const states_1 = require("encamp-shared/dist/constants/states");
const facilityState_1 = require("../facilityState");
/**
 * States that have not adopted subpart L. A less-stringent federal provision
 * does not apply in an authorized state until the state adopts it
 * (40 CFR 271.1(i)(2)). The "adopted everywhere else" default is unconfirmed
 * by the waste SME; see `EPISODIC_EXPECTATIONS`.
 */
exports.SUBPART_L_NOT_ADOPTED = new Set([
    "CA",
    "CT",
    "MA",
    "MN",
]);
/** Raw `Facility.state`; null answers federally, junk throws. */
function getEpisodicRelief(facilityState) {
    const state = (0, facilityState_1.parseFacilityState)(facilityState);
    if (state === null || !exports.SUBPART_L_NOT_ADOPTED.has(state)) {
        return { isAvailable: true };
    }
    const stateName = states_1.stateNamesByAbbreviation.get(state) ?? state;
    return {
        isAvailable: false,
        reason: `${stateName} hasn't adopted the episodic event provision (40 CFR 262 subpart L), ` +
            "so the event will be recorded, but generator status and deadlines won't change",
    };
}
/**
 * The relief as a predicate — what gates behavior besides attachment, and what
 * the UI uses to hide the feature in non-adopting states.
 */
function episodicEventsApplicableForState(state) {
    return getEpisodicRelief(state).isAvailable;
}
//# sourceMappingURL=relief.js.map